// experimental state to drive profile layout back navigation
// shouldn't need to be reactive, so just using a global object

// reset by the /teach and /learn layouts
export const ReturnNavState = {
  appMode: 'learn', // learn / teach
  l2: 'es',
};
